import { fetchFactors, fetchReputationByVtrId } from '@api/company-reputation';
import { Box, Tabs, Tab, IconButton } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { CompanyReputationTab } from './Tabs/CompanyReputationTab/CompanyReputationTab';
import { GeneralFactorsTab } from './Tabs/GeneralFactorsTab/GeneralFactorsTab';
import { CompanyReputation, FactorMeta } from './types';
import { AppBarTitle } from '@components/app-bar-title';
import { RiSearchFill } from 'react-icons/ri';
import { usePintMaster } from '@lib/common';
import { GeneralBadgeScoring } from './Tabs/GeneralBadgeTab/GeneralBadgeTab';
import TuneIcon from '@material-ui/icons/Tune';
import EmojiEventsIcon from '@material-ui/icons/EmojiEvents';
import AssessmentIcon from '@material-ui/icons/Assessment';
import { forkJoin, of } from 'rxjs';
import * as companyService from '@api/company';
import { catchError } from 'rxjs/operators';
import { useSnackbar } from 'notistack';

export const CompanyReputationPage = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const [company, setCompany] = useState<CompanyReputation | null>(null);
  const [factors, setFactors] = useState<Record<string, FactorMeta>>({});
  // const [score, setScore] = useState<number | null>(null);
  const [scoreData, setScoreData] = useState({
    computedScore: 0,
    overrideScore: null as number | null,
    displayScore: 0,
  });
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [loadingFactors, setLoadingFactors] = useState(false);
  const [factorsError, setFactorsError] = useState(false);
  const [badge, setBadge] = useState<any>();
  const { loading: loading_badges, master: reputation } = usePintMaster('reputation_badge');

  useEffect(() => {
    setLoadingFactors(true);
    const subscription = fetchFactors().subscribe({
      next: data => {
        setFactors(data.factors);
        setLoadingFactors(false);
      },
      error: err => {
        console.error(err);
        setFactorsError(true);
        setLoadingFactors(false);
      },
    });

    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    if (Array.isArray(reputation)) {
      setBadge(reputation);
    } else {
      setBadge([]); // safe fallback
    }
  }, [reputation]);

  const handleFetch = (vtrId: string) => {
    setLoading(true);

    forkJoin({
      reputation: fetchReputationByVtrId(vtrId).pipe(
        catchError(err => {
          console.error('Failed to fetch reputation:', err);
          return of(null);
        }),
      ),
      companyData: companyService.get(vtrId).pipe(
        catchError(err => {
          console.error('Failed to fetch company:', err);
          return of(null);
        }),
      ),
    }).subscribe({
      next: ({ reputation, companyData }) => {
        setCompany(reputation ? reputation?.company : null);

        if (!reputation) {
          enqueueSnackbar('Failed to fetch company reputation details.', {
            variant: 'error',
          });
        }
        
        if (!companyData) {
          enqueueSnackbar('Failed to fetch company editorial score details.', {
            variant: 'error',
          });
        }
     /*      // Option 1: Show 0 / -
          setScoreData({
            computedScore: 0,
            overrideScore: null,
            displayScore: 0,
          });

          // OR Option 2: Hide the score section
          // setScoreData(null);

          setLoading(false);
          return;
        }
 */
        const computedScore = reputation
          ? Number(reputation.computed_reputation_score ?? 0)
          : 0;
        const overrideScore =
          companyData?.override_reputation_score == null ||
          companyData.override_reputation_score === ""
            ? null
            : Number(companyData.override_reputation_score);

        setScoreData({
          computedScore,
          overrideScore,
          displayScore: overrideScore ?? computedScore,
        });

        setLoading(false);
      },
      error: err => {
        console.error(err);
        setLoading(false);
      },
    });
  };

  return (
    <>
      <AppBarTitle>
        <IconButton color="inherit">
          <RiSearchFill />
        </IconButton>{' '}
        Company Reputation Score - Admin
      </AppBarTitle>
      <Box>
        <Box
          mb={3}
          p={1}
          style={{
            backgroundColor: '#F5F7FA',
            borderRadius: 12,
          }}>
          <Tabs
            value={tabIndex}
            onChange={(_, newValue) => setTabIndex(newValue)}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            TabIndicatorProps={{
              style: {
                height: 4,
                borderRadius: 4,
              },
            }}>
            <Tab
              icon={<TuneIcon />}
              label="General Scoring Factors"
              style={{ textTransform: 'none', fontWeight: 600 }}
            />
            <Tab
              icon={<EmojiEventsIcon />}
              label="General Badge Scoring"
              style={{ textTransform: 'none', fontWeight: 600 }}
            />
            <Tab
              icon={<AssessmentIcon />}
              label="Company Reputation Score"
              style={{ textTransform: 'none', fontWeight: 600 }}
            />
          </Tabs>
        </Box>

        <Box mt={3}>
          {tabIndex === 0 && (
            <GeneralFactorsTab factors={factors} loading={loadingFactors} error={factorsError} />
          )}
          {tabIndex === 1 && <GeneralBadgeScoring loading={loading_badges} badges={badge} />}
          {tabIndex === 2 && (
            <CompanyReputationTab
              company={company}
              factors={factors}
              // score={score}
              computedScore={scoreData.computedScore}
              overrideScore={scoreData.overrideScore}
              displayScore={scoreData.displayScore}
              badges={badge}
              loading={loading}
              onFetch={handleFetch}
            />
          )}
        </Box>
      </Box>
    </>
  );
};
